
import React, { useContext } from "react";
import { FaGlobe, FaRecycle, FaTree, FaClipboardCheck } from 'react-icons/fa';
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import './AuditGlobal.css';
import BannerImage from './audit_hero.png';

function ISO14K1() {
  const navigate = useNavigate();
  const { isAuthenticated } = useContext(AuthContext);

  const handleBooking = () => {
    if (isAuthenticated) {
      navigate('/booking/iso-14001-audit');
    } else {
      navigate('/login', { state: { from: '/booking/iso-14001-audit' } });
    }
  };

  return (
    <div className="audit-page">
      <div className="audit-max-width">

        {/* --- HERO --- */}
        <div className="audit-hero" style={{ backgroundImage: `url(${BannerImage})` }}>
          <span className="hero-tag">Environmental Audit</span>
          <h1 className="hero-title">ISO 14001 Audit</h1>
          <p className="hero-subtitle">
            Validating your commitment to the planet. Ensuring your Environmental Management System (EMS)
            meets international standards.
          </p>
          <button onClick={handleBooking} className="btn-hero">
            Book Audit <span style={{ fontSize: '1.2em' }}>→</span>
          </button>
        </div>

        {/* --- CONTENT --- */}
        <div className="detail-content">

          <div className="content-article">
            <div className="article-section">
              <h2 className="article-heading">Why Audit Environmental Systems?</h2>
              <p className="article-text">
                Industries face growing challenges: climate change, water scarcity, and pollution. An ISO 14001 Audit
                is not just a checklist; it represents a fundamental verification of your organization's sustainability.
                It ensures you are balancing economic growth with environmental protection.
              </p>
            </div>

            <div className="article-section">
              <h2 className="article-heading">Audit Focus Areas</h2>
              <p className="article-text">
                The audit evaluates the entire PDCA cycle:
                <br />- <strong>Policy:</strong> Is there a clear commitment from leadership?
                <br />- <strong>Aspects & Impacts:</strong> Have all environmental risks been identified?
                <br />- <strong>Compliance:</strong> Are you meeting all legal requirements?
                <br />- <strong>Operational Control:</strong> Are controls effective in the real world?
              </p>
            </div>

            <div className="article-section">
              <h2 className="article-heading">Strategic Value</h2>
              <p className="article-text">
                A successful audit proves to stakeholders that your green claims are valid. It reduces liability,
                minimizes waste costs, and opens doors to green markets.
              </p>
            </div>
          </div>

          {/* --- SIDEBAR --- */}
          <div className="content-sidebar">
            <div className="sidebar-widget">
              <h4 className="widget-title">Key Audit Points</h4>
              <ul className="key-list">
                <li><FaTree className="check-icon" /> Biodiversity Protection</li>
                <li><FaRecycle className="check-icon" /> Waste Management</li>
                <li><FaClipboardCheck className="check-icon" /> Legal Register</li>
                <li><FaGlobe className="check-icon" /> Carbon Footprint</li>
              </ul>
            </div>

            <div className="sidebar-widget" style={{ background: 'linear-gradient(135deg, #111 0%, #222 100%)', border: '1px solid #333' }}>
              <h4 className="widget-title">Get Certified</h4>
              <p style={{ color: '#ccc', marginBottom: '20px', fontSize: '0.9rem' }}>
                Start your journey to ISO 14001 certification.
              </p>

              <button
                onClick={handleBooking}
                className="btn-primary"
                style={{ width: '100%', justifyContent: 'center' }}
              >
                Book Now
              </button>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}

export default ISO14K1;
